import { Component, Input } from '@angular/core';
import { Event } from 'src/app/model/event';
import { EventType } from 'src/app/model/event-type';

@Component({
  selector: 'calendar-day',
  templateUrl: 'calendar-day.html',
  styleUrls: ["calendar-day.css"]
})

export class CalendarDayComponent {
  @Input("header") header: string;
  @Input("events") events: Event[];

  constructor() { }

  private getEventColorString(type: EventType): string {
    switch (type) {
      case EventType.Practice: return "#cc1236";
      case EventType.LeagueMatch: return "#530716";
      case EventType.Tournament: return "#cc6679";
      case EventType.Other: return "#585858";
      default: return "#000000";
    }
  }

  private eventClick(event: Event): void {
    localStorage.setItem("eventDate", event.date.toString());
  }
}